export default class SVGConverter {

    target = null;

    //#region instance

    static instance = null;

    static get Instance() {
        if (this._instance == null) {
            this._instance = new SVGConverter();
        }

        return this._instance;
    }

    //#endregion

    //#region 需要轉換的SVG網址

    _url = [];

    get url() {
        return this._url;
    }

    set url(_url) {
        if (_url != null || _url != undefined) {
            if (this._url !== _url) {
                this._url = _url;
                this.isChange = true;
                this.clearTarget();
                this.loadSVG();
            }
        }
    }

    get tag() {
        return this._url.join('-');
    }

    //#endregion

    //#region 尺寸

    _size = { w: 0, h: 0 };

    get size() {
        return this._size;
    }

    set size(_size) {
        if (_size.w) this._size.w = _size.w;
        if (_size.h) this._size.h = _size.h;
    }

    get width() {
        return this._size.w;
    }

    set width(_width) {
        this._size.w = _width;
    }

    get height() {
        return this._size.h;
    }

    set height(_height) {
        this._size.h = _height;
    }

    //#endregion

    //#region SVG縮放倍率

    _scale = 1;

    get scale() {
        return this._scale;
    }

    set scale(_scale) {
        if (_scale != null || _scale != undefined) {
            if (this._scale !== _scale) {
                this._scale = _scale;
                this.isChange = true;
                this.clearTarget();
            }
        }
    }

    //#endregion

    //#region SVG偏移量

    _offset = { x: 0, y: 0 };

    get offset() {
        return this._offset;
    }

    set offset(_offset) {
        if (_offset != null || _offset != undefined) {
            if (this._offset.x !== _offset.x && this._offset.y !== _offset.y) {
                this._offset.x = _offset.x;
                this._offset.y = _offset.y;
                this.isChange = true;
                this.clearTarget();
            }
        }
    }

    get offsetX() {
        return this._offset.x;
    }

    set offsetX(_offsetX) {
        if (_offsetX != null || _offsetX != undefined) {
            if (this._offset.x !== _offsetX) {
                this._offset.x = _offsetX;
                this.isChange = true;
                this.clearTarget();
            }
        }
    }

    get offsetY() {
        return this._offset.y;
    }

    set offsetY(_offsetY) {
        if (_offsetY != null || _offsetY != undefined) {
            if (this._offset.y !== _offsetY) {
                this._offset.y = _offsetY;
                this.isChange = true;
                this.clearTarget();
            }
        }
    }

    //#endregion

    // 是否需要轉換畫面
    isChange = false;

    // 存放SVG轉換資料
    svgDataMap = new Map();

    constructor(target, width, height) {
        this.target = target;
        this.width = width;
        this.height = height;

        this.init();
    }

    init() {
        setInterval(() => {
            if (this.isChange) {
                this.isChange = false;
                this.update(this.tag, this.offsetX, this.offsetY, this.scale);
            }
        }, 100);
    }

    loadSVG() {
        const svgData = this.svgDataMap.get(this.tag);

        if (svgData) return;

        let promises = [];

        for (let i = 0; i < this.url.length; i++) {
            const p = fetch(this.url[i])
                .then(response => response.text())
                .then(svgString => {
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(svgString, "image/svg+xml");

                    const svgContent = new XMLSerializer().serializeToString(xmlDoc);
                    const svgImage = this.loadImage(`data:image/svg+xml;base64,${btoa(svgContent)}`)

                    // 遍歷 defs 元素中的 image 元素，將相對路徑轉換成絕對路徑
                    const imageElements = xmlDoc.querySelectorAll("defs image");

                    // 使用 Promise.all 等待所有圖片加載完畢
                    let imageLoadPromises = Array.from(imageElements).map(imageElement => {
                        return new Promise(resolve => {
                            const href = imageElement.getAttribute("xlink:href");
                            if (href) {
                                const realUrl = this.resolveRelativePath(this.url[i], href);
                                const img = new Image();
                                img.crossOrigin = "Anonymous";  // 允許跨域請求
                                img.src = realUrl;
                                img.onload = () => {
                                    resolve({ element: imageElement, img });
                                };
                            } else {
                                resolve({ element: imageElement, img: null });
                            }
                        });
                    });

                    return Promise.all([...imageLoadPromises, svgImage]).then(imagesData => {

                        if (imagesData.length == 1) {
                            return ({
                                xmlDoc,
                                svgDataElement: null,
                                svgDataImage: null,
                                svgImage: imagesData[0]
                            })
                        } else {
                            return ({
                                xmlDoc,
                                svgDataElement: imagesData[0].element,
                                svgDataImage: imagesData[0].img,
                                svgImage: imagesData[1]
                            })
                        }
                    });
                })
                .catch(error => console.error("Error fetching SVG:", error));

            promises.push(p);
        }

        Promise.all(promises)
            .then(data => {
                this.svgDataMap.set(this.tag, data);
                this.isChange = true;
            })
            .catch(error => {
                console.error(error);
            })
    }

    update(tag, offsetX, offsetY, scale) {
        const svgData = this.svgDataMap.get(tag);

        // 如果該轉換器沒有SVG資料，不執行
        if (!svgData) return;

        const newWidth = this.width * scale / svgData.length;
        const newHeight = this.height * scale;

        const myDiv = document.createElement('div');
        myDiv.style.width = `${this.width}px`;
        myDiv.style.height = `${this.height}px`;

        // 繪製 SVG
        for (let i = 0; i < svgData.length; i++) {
            const data = svgData[i];

            if (!data) continue;

            // 繪製圖片
            if (data.svgDataImage) {
                data.svgDataImage.style.position = 'absolute';
                data.svgDataImage.style.left = `${offsetX + newWidth * i}px`;
                data.svgDataImage.style.top = `${offsetY}px`;
                data.svgDataImage.style.width = `${newWidth}px`;
                data.svgDataImage.style.height = `${newHeight}px`;
                myDiv.appendChild(data.svgDataImage);
            }
            data.svgImage.style.position = 'absolute';
            data.svgImage.style.left = `${offsetX + newWidth * i}px`;
            data.svgImage.style.top = `${offsetY}px`;
            data.svgImage.style.width = `${newWidth}px`;
            data.svgImage.style.height = `${newHeight}px`;
            myDiv.appendChild(data.svgImage);
        }

        this.target.innerHTML =
            "<svg xmlns='http://www.w3.org/2000/svg' width='" + this.width + "px' height='" + this.height + "px'>" +
            "<foreignObject width='100%' height='100%'>" +
            "<div xmlns='http://www.w3.org/1999/xhtml' style='font: " + 0 + "px sans-serif;'>" +
            myDiv.innerHTML +
            "</div>" +
            "</foreignObject>" +
            "</svg>";

        document.getElementById("left-page-svg").style.visibility = 'hidden';
        document.getElementById("right-page-svg").style.visibility = 'hidden';
    }

    clearTarget() {
        console.log("this.url:", this.url)

        document.getElementById("left-page-svg").style.visibility = 'visible';
        document.getElementById("right-page-svg").style.visibility = 'visible';

        this.target.innerHTML = "";
    }

    resolveRelativePath(basePath, relativePath) {
        const splitRelativePath = relativePath.split('/');
        const forwardCount = splitRelativePath.filter(m => m === '.').length;
        const realUrl = basePath.split('/').slice(0, -forwardCount).join('/') + '/' + splitRelativePath.slice(forwardCount).join('/');
        return realUrl;
    }

    loadImage(url) {
        return new Promise((resolve, reject) => {
            const image = new Image();

            image.onload = function () {
                resolve(image);
            };

            image.onerror = function () {
                reject(null);
            };

            image.src = url;
        });
    }
}